export const red = {
    50: '#FDEDED',
    100: '#FAD1D1',
    150: '#F7B6B6',
    200: '#F49A9A',
    300: '#F07E7E',
    400: '#ED6363',
    500: '#EA4747',
    600: '#C53C3F',
    700: '#A03136',
    800: '#7D272C',
    850: '#5B1E22',
    900: '#350F0F',
    950: '#1F0808'
};

//# sourceMappingURL=red.js.map